module.exports = __webpack_public_path__ + "static/media/mongodb.79bb0d3f.svg";